import { Component } from '@angular/core';

import { App, NavController, ModalController, ViewController } from 'ionic-angular';


@Component({
  template: `
    <ion-list>
      <button ion-item (click)="close('http://shpesouthtexas.org')">SHPE South Texas</button>
      <button ion-item (click)="close('https://issuu.com/digitalpublish/docs/mcallenvisitorguide')">McAllen Visitor Guide</button>
      <button ion-item (click)="close('https://drive.google.com/file/d/18JEFrGR-5euGGkO2nO779I5_MqIRxOsD/view')">McAllen Convention Center Map</button>
      <button ion-item (click)="support()">Sponsors</button>
    </ion-list>
  `
})
export class PopoverPage {

  constructor(
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public app: App,
    public modalCtrl: ModalController
  ) { }

  support() {
    this.app.getRootNav().push('SupportPage');
    this.viewCtrl.dismiss();
  }

  close(url: string) {
    window.open(url, '_blank');
    this.viewCtrl.dismiss();
  }
}


// WEBPACK FOOTER //
// ./src/pages/about-popover/about-popover.ts